module.exports = __webpack_public_path__ + "media/images/flags/1x1/hun-d25970eefed06929d457299a7b2e94e3.svg";